import { jsx as _jsx } from "react/jsx-runtime";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
window.Components.Buttons.Delete = createReactClass({
  onClick() {
    if (this.props.handler) {
      return this.props.handler();
    }
  },
  propTypes() {
    return {
      handler: PropTypes.func
    };
  },
  render() {
    return /*#__PURE__*/_jsx("i", {
      className: "fa fa-times u-clickable",
      onClick: this.onClick
    });
  },
  displayName: "Delete"
});
window._jsx = _jsx;